import { useMemo } from 'react';
import moment from 'moment';
import MantineTable from '../../../common/table/mantine';
import { NumberInput } from '@mantine/core';

const initialState = {
  columnPinning: {
    left: ['material', 'material_description'],
    right: [],
  },
  sorting: [
    {
      id: 'material_description',
      desc: false,
    },
  ],
};

const AvicTable = ({ readOnly = false, channels, loading, onChannelChange = () => {} }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'material',
        header: 'SKU No',
      },
      {
        accessorKey: 'material_description',
        header: 'SKU Description',
      },
      {
        accessorKey: 'sales_org',
        header: 'Sales Org',
      },
      {
        accessorKey: 'distribution_channel',
        header: 'Distribution Channel',
      },
      {
        accessorKey: 'condition_type',
        header: 'Condn Type',
      },
      {
        accessorKey: 'key_combination',
        header: 'Key Combn',
      },
      {
        accessorKey: 'cost_per_hl',
        header: 'Cost/HL',
        Cell: ({
          row: {
            original: { existing, cost_per_hl, distribution_channel },
          },
        }) => {
          return !existing ? (
            <NumberInput
              value={parseFloat(cost_per_hl) || undefined}
              precision={3}
              min={0.01}
              step={0.01}
              max={1000000}
              disabled={readOnly}
              onChange={(value) => onChannelChange('cost_per_hl', value, distribution_channel)}
            />
          ) : (
            cost_per_hl
          );
        },
      },
      {
        accessorKey: 'cost_per_100hl',
        header: 'Cost/100HL',
        Cell: ({
          row: {
            original: { cost_per_100hl },
          },
        }) => {
          return cost_per_100hl;
        },
      },
      {
        accessorKey: 'currency_key',
        header: 'Curr',
      },
      {
        accessorKey: 'per',
        header: 'Unit',
      },
      {
        accessorKey: 'unit_of_measure',
        header: 'Uom',
      },
      {
        accessorKey: 'valid_from',
        header: 'Valid From',
        Cell: ({ row }) => moment(row.original.valid_from).format('YYYY-MM-DD'),
      },
      {
        accessorKey: 'valid_to',
        header: 'Valid To',
        Cell: ({ row }) => moment(row.original.valid_to).format('YYYY-MM-DD'),
      },
    ],
    [channels],
  );

  return (
    <>
      <MantineTable
        columns={columns}
        initialData={channels}
        enableRowSelection={false}
        loading={loading}
        showSelectedToggle={false}
        hideSelectColumn={true}
        showResetAll={false}
        pageSize={10}
        initialState={initialState}
        enableColumnFilter={false}
        enableFilters={false}
        enableExport={false}
        columnFilterDisplayMode={false}
      />
    </>
  );
};

export default AvicTable;
